import moment from 'moment';

momentProvider.$inject = [];

export interface MomentProvider {
  locale(newLocale: string): void;
  $get(): typeof moment;
}

export function momentProvider(): MomentProvider {
  if (typeof moment === 'undefined' || !moment) {
    throw new Error("Can't load moment.js");
  }

  return {
    locale(newLocale) {
      moment().locale(newLocale);
    },
    $get: () => moment,
  };
}
